import React from 'react';
import { Link } from 'react-router-dom';
import * as Icons from 'lucide-react';
import { ChevronDown, Home, Layers, Building2, Users, Briefcase, MessageSquare, Globe2 } from 'lucide-react';
import { ABOUT_LINKS } from './aboutLinks';
import { MARKET_LINKS } from '../../data/seoLinks';

const MobLink = ({ to, children, Ic }) => (
  <Link to={to} className="flex items-center gap-2 py-3 px-3 text-[#0e1116] hover:text-green-600 hover:bg-gray-50 rounded">
    {Ic && <Ic className="w-4 h-4 text-orange-500" />} {children}
  </Link>
);

const MobileMenu = ({ services, industries, t }) => (
  <div className="lg:hidden border-t border-gray-200 bg-white max-h-[80vh] overflow-y-auto">
    <div className="px-4 py-4 space-y-1 text-sm">
      <MobLink to="/" Ic={Home}>{t('home')}</MobLink>

      <details className="group">
        <summary className="flex items-center justify-between py-3 px-3 text-[#0e1116] cursor-pointer hover:text-green-600">
          <span className="flex items-center gap-2"><Layers className="w-4 h-4" /> {t('services')}</span>
          <ChevronDown className="w-4 h-4" />
        </summary>
        <div className="pl-4 space-y-1 py-1">
          {services.map(s => {
            const Ic = Icons[s.icon] || Icons.Box;
            return (
              <Link key={s.slug} to={`/services/${s.slug}`} className="flex items-center gap-2 py-2 px-3 text-gray-600 hover:text-green-600">
                <Ic className="w-3.5 h-3.5 text-orange-500" />{s.title}
              </Link>
            );
          })}
          <Link to="/services" className="block py-2 px-3 text-orange-500 font-bold text-xs uppercase tracking-wider">All services →</Link>
        </div>
      </details>

      <details className="group">
        <summary className="flex items-center justify-between py-3 px-3 text-[#0e1116] cursor-pointer hover:text-green-600">
          <span className="flex items-center gap-2"><Building2 className="w-4 h-4" /> {t('industries')}</span>
          <ChevronDown className="w-4 h-4" />
        </summary>
        <div className="pl-4 space-y-1 py-1">
          {industries.map(ind => {
            const Ic = Icons[ind.icon] || Icons.Briefcase;
            return (
              <Link key={ind.slug} to={`/industries/${ind.slug}`} className="flex items-center gap-2 py-2 px-3 text-gray-600 hover:text-green-600">
                <Ic className="w-3.5 h-3.5 text-orange-500" />{ind.title}
              </Link>
            );
          })}
          <Link to="/industries" className="block py-2 px-3 text-orange-500 font-bold text-xs uppercase tracking-wider">All industries →</Link>
        </div>
      </details>

      <details className="group">
        <summary className="flex items-center justify-between py-3 px-3 text-[#0e1116] cursor-pointer hover:text-green-600">
          <span className="flex items-center gap-2"><Users className="w-4 h-4" /> {t('about')}</span>
          <ChevronDown className="w-4 h-4" />
        </summary>
        <div className="pl-4 space-y-1 py-1">
          {ABOUT_LINKS.map(a => {
            const Ic = Icons[a.icon] || Icons.Info;
            return (
              <Link key={a.slug} to={a.to} className="flex items-center gap-2 py-2 px-3 text-gray-600 hover:text-green-600">
                <Ic className="w-3.5 h-3.5 text-orange-500" />{a.label}
              </Link>
            );
          })}
        </div>
      </details>

      <details className="group">
        <summary className="flex items-center justify-between py-3 px-3 text-[#0e1116] cursor-pointer hover:text-green-600">
          <span className="flex items-center gap-2"><Globe2 className="w-4 h-4" /> Markets</span>
          <ChevronDown className="w-4 h-4" />
        </summary>
        <div className="pl-4 space-y-1 py-1">
          {MARKET_LINKS.map(l => (
            <Link key={l.to} to={l.to} className="flex items-center gap-2 py-2 px-3 text-gray-600 hover:text-green-600">
              <Globe2 className="w-3.5 h-3.5 text-orange-500" />{l.label}
            </Link>
          ))}
        </div>
      </details>
      <MobLink to="/careers" Ic={Briefcase}>{t('careers')}</MobLink>
      <MobLink to="/contact" Ic={MessageSquare}>{t('contact')}</MobLink>
      <Link to="/get-quote" className="block mt-3 bg-orange-500 text-white text-center font-bold py-3 rounded">{t('getStarted')}</Link>
    </div>
  </div>
);

export default MobileMenu;
